import React from "react";
import { IconButton } from "@chakra-ui/react";
import { FiLogOut } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { logOut } from "../../lib/auth";
import { ArawaksLogo } from "./ArawaksLogo";

export function ReducedTopbar({ showLogout = false }) {
  const navigate = useNavigate();

  const logout = async () => {
    await logOut();
    navigate("/registro", { replace: true });
  };

  return <>
    <ArawaksLogo lightSrc="/brand/arawaks-black.png" darkSrc="/brand/arawaks-white.png" position="absolute" zIndex="3" top={{ base: "5", lg: "8" }} left={{ base: "5", lg: "8" }} alt="Arawaks" w={{ base: "112px", md: "136px" }} h="34px"/>
    {showLogout && <IconButton position="absolute" zIndex="3" top={{ base: "5", lg: "8" }} right={{ base: "5", lg: "8" }} aria-label="Cerrar sesión" variant="ghost" color="public.fg.muted" onClick={logout}><FiLogOut/></IconButton>}
  </>;
}

export default ReducedTopbar;